/* eslint-disable no-use-before-define */
import {css} from '@emotion/core'
import {mediaQueries} from '../twd'

export const sectionCss = css`
    background-color: #ffffff;
    ${mediaQueries.notXs} {
        padding: 0 20px;
    }
    ${mediaQueries.xs} {
        padding: 0px;
    }
`

export const textAlignRight = css`
    ${mediaQueries.notXs} { text-align: right }
`

export const backgroundColor= css`
    ${mediaQueries.notXs} { background-color: #f6f6f6; }
`

export const displayInline = css`
    ${mediaQueries.notXs} { display: inline; }
`